<template>
  <div class="footer-action">
    <div class="float-right">
      <button class="btn btn-primary" :disabled="!isReportSelected && !allReportFields.length" @click="exportReport">Run Report</button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  components: {

  },

  data() {
    return {
      label: '',
      timeoutId: null,
    }
  },
  computed: {
    ...mapGetters({
      selectedExportReport: "reportList/selectedExportReport",
      exportSelect: "reportList/exportSelect",
      allReportFields: 'reportList/allReportFields',
    }),
    isReportSelected() {
      return this.selectedExportReport && Object.keys(this.selectedExportReport).length > 0;
    }
  },
  methods: {
    exportReport() {
      if(this.exportSelect === 'collection') {
        this.$store.dispatch('reportList/reportList');
        return;
      }
      this.$store.dispatch('reportList/exportReport', this.selectedExportReport.id);
    }
  },
}
</script>

<style lang="scss" scoped>
.footer-action {
  width: 100%;
  height: 66px;
  position: absolute;
  bottom: 0;
  background-color: #FFFFFF;
  padding: 16px 16px 16px 464px;
}
</style>